import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ActionIcon, Group, Tabs } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Container, LayoutStandard } from 'components';
import { AuthorityConstants, RouteConstants } from 'constant';
import { displayClasses } from 'styles';
import { AppUtils } from 'utils';

import TemplateListTab from './templates/TemplateListTab';
import AgentListTab from './agents/AgentListTab';

const PermissionsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState<string | null>(tabParam === 'agents' ? 'agents' : 'templates');

  const handleNewTemplate = () => {
    navigate(`${RouteConstants.ROUTE_PERMISSIONS}/sabloni/novi`);
  };

  return (
    <LayoutStandard title={AppUtils.composeTabTitle(t('header.permissions'))} authority={AuthorityConstants.ROLE_PRF_CUD}>
      <Container>
        <Tabs value={activeTab} onChange={setActiveTab} variant="unstyled">
          <Group justify="space-between" align="flex-end">
            <Tabs.List>
              <Tabs.Tab value="templates" className={displayClasses.tabList}>
                {t('permissions.tabs.templates')}
              </Tabs.Tab>
              <Tabs.Tab value="agents" className={displayClasses.tabList}>
                {t('permissions.tabs.agents')}
              </Tabs.Tab>
            </Tabs.List>

            {activeTab === 'templates' && (
              <ActionIcon size="lg" color="green" onClick={handleNewTemplate} mb="md" style={{ cursor: 'pointer' }}>
                <IconPlus size={20} />
              </ActionIcon>
            )}
          </Group>

          <Tabs.Panel value="templates" className={displayClasses.tabContent}>
            <TemplateListTab />
          </Tabs.Panel>

          <Tabs.Panel value="agents" className={displayClasses.tabContent}>
            <AgentListTab />
          </Tabs.Panel>
        </Tabs>
      </Container>
    </LayoutStandard>
  );
};

export default PermissionsPage;
